module.exports = __webpack_public_path__ + "img/About_Four.63367876.png";